// extracted by mini-css-extract-plugin
export var btnContainer = "button-module--btnContainer--V1m7O";
export var upBtnContainer = "button-module--upBtnContainer--3UXfd";
export var btnTitleFont = "button-module--btnTitleFont--1FdKr";